module.exports = __webpack_public_path__ + "media/images/mailer/send_instructions/s3_credentials-3eb1dcd2906a058919a35c3cd5b76c1d.png";